module.exports = __webpack_public_path__ + "assets/retina_PentagonDetailed.f8b7a6bc956e73e45b5f5360ed5bb00a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_PentagonDetailed.png
// module id = 703
// module chunks = 0